import { AuthenticationStore } from '@/state/authentication.store';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authenticatedGuard: CanActivateFn = async () => {
  const store = inject(AuthenticationStore);
  const router = inject(Router);
  const loggedIn = store.isLoggedIn();

  if (!loggedIn) {
    router.navigateByUrl('/auth/login');
    return false;
  }

  await store.updateCurrentUser();
  // Updating the current user will trigger a refresh if the access token is expired
  // Expired refresh token will make the user logged out
  if (!store.isLoggedIn()) {
    router.navigateByUrl('/auth/login');
    return false;
  }

  const isPlatformPortalUser = store.isPlatformPortalUser();

  if (!isPlatformPortalUser) {
    router.navigateByUrl('/auth/invalid-role');
    return false;
  }

  return true;
};
